// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({"354": "lib-axios","535": "lib-router","783": "lib-react",}[chunkId] || chunkId) + "." + {"122": "21a578a4","232": "ffc834c3","234": "06463438","354": "9c6094ad","535": "61821660","585": "a85aeba3","732": "633cb478","783": "b882e271",}[chunkId] + ".js"
}